import { Component, Input } from '@angular/core';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { StudentassignmentsService } from '../../../inputfileds/form_services/Assignmentsservices/studentassignments/studentassignments.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-studentassignments',
  standalone: true,
  imports: [
    DynamicFormQuestionComponent,
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatIconModule,
    TranslateDirective
  ],
  providers: [QuestionControlService],
  templateUrl: './studentassignments.component.html',
  styleUrls: ['./studentassignments.component.scss'],
})
export class StudentassignmentsComponent {
  questions$: Observable<Inputfiledsbase<string>[]> | null = null;
  questions: Inputfiledsbase<string>[] = [];
  form!: FormGroup;
  assignments: any[] = [];
  userData: any; // Declare userData here without initializing

  constructor(
    private studentAssignmentsService: StudentassignmentsService,
    private qcs: QuestionControlService,
    private router: Router
  ) {
    const userJson = sessionStorage.getItem('user');
    if (userJson) {
      try {
        this.userData = JSON.parse(userJson);
      } catch (e) {
        console.error('Could not parse user data from session storage', e);
      }
    }
  }

  ngOnInit(): void {
    this.questions$ = this.studentAssignmentsService.getstudentAssignments();
    this.questions$.subscribe((q) => {
      this.questions = q;
      this.form = this.qcs.toFormGroup(this.questions);
    });

    this.assignments = [
      {
        id: 1,
        subject: 'Mathematics',
        title: 'Calculus Integration Assignment',
        status: 'Pending',
        type: 'Due',
        date: '31 May 2025',
      },
      {
        id: 2,
        subject: 'Science',
        title: 'Biology Lab Report',
        status: 'Pending',
        type: 'Submitted',
        date: '15 April 2025',
      },
      {
        id: 3,
        subject: 'History',
        title: 'World War II Essay',
        status: 'Pending',
        type: 'Due',
        date: '10 June 2025',
      },
      {
        id: 4,
        subject: 'Physics',
        title: 'Mechanics Lab Report',
        status: 'Submitted',
        type: 'Submitted',
        date: '15 April 2025',
      },
      {
        id: 5,
        subject: 'English',
        title: 'Literature Review Essay',
        status: 'Submitted',
        type: 'In Review',
        date: '15 April 2025',
      },
      {
        id: 6,
        subject: 'Biology',
        title: 'Genetics Research Paper',
        status: 'Graded',
        type: 'Due',
        date: '10 June 2025',
      },
    ];
  }

  onSubjectView(assignment: any) {
    if (this.userData && this.userData.data && this.userData.data.id) {
      this.router.navigate([
        `/assignments/student/${this.userData.data.id}/${assignment.id}`,
      ]);
    } else {
      console.error('User data or ID not found. Cannot navigate.');
    }
  }
}
